import React, { useContext } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Button, Modal, Col, Row, Card, Spinner, Alert } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/SaveRounded';
import ApiAuth from '../../../core/api/api.auth';
import ContextApp from "../../../core/contexts/context.app";
import ServiceStorage from '../../../core/services/service.storage';
import ServiceApi from '../../../core/services/service.api';
import SwalMessage from './SwalMessage';
import { useNavigate } from "react-router-dom";


const Login = () => {
  const ctx = useContext(ContextApp);
  const navigate = useNavigate();
  const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue } = useForm({
    defaultValues: { id: 0 }
  });

  const onSubmit =
    async (data) => {
      //------------------ Login ----------------------
      try {
        const response = await ApiAuth.login(data);
        if (response.succeeded == true) {
          ServiceStorage.setToken(response.data.jwToken, response.data.refreshToken);
          ServiceApi.setToken();
          ctx.setIsAuth(true);
          navigate('/dashboard');
        }
        else
          SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        // history.goBack();
      } catch (error) {
        console.log("error=", error);
      }
    }
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5 mx-auto mb-5" >
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Card style={{ width: '25rem' }} className="mx-auto center">
              <Card.Body>
                <Card.Title>جهت ورود اطلاعات خود را وارد نمایید</Card.Title>
                <Controller
                  name="userName"
                  control={control}
                  rules={{ required: true, }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام کاربری"
                      id='userName'
                      margin="normal"
                      variant="outlined"
                      size='small'
                      value={value || ""}
                      onInput={onChange}
                      autoComplete='true'
                    />
                  )}
                />
                {errors.user && <span>لطفا نام کاربری را وارد نمایید</span>}

                <Controller
                  name="password"
                  control={control}
                  rules={{ required: true, }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="رمز عبور"
                      type='password'
                      id='password'
                      margin="normal"
                      variant="outlined"
                      size='small'
                      value={value || ""}
                      onInput={onChange}
                      autoComplete='true'
                    />
                  )}
                />
                {errors.pass && <span>لطفا رمز عبور را وارد نمایید</span>}

                <Button variant="success" type="submit" disabled={isSubmitting}>
                  {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                  <SaveIcon />  ورود
                                </Button>
              </Card.Body>
            </Card>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
